export const rxzxRouter = [
  {
    path: '/rxzx',
    component: () => import('./views/index')
  },
  {
    path: '/rxzx/teams',
    component: () => import('./views/teams')
  },
  {
    path: '/rxzx/intro',
    component: () => import('./views/intro')
  }
]



// WEBPACK FOOTER //
// ./src/page/rxzx/router.js